import { login as _login, logout } from '@utils/auth'


// initial state
// shape: [{ id, quantity }]
const state = {
  // 自动获取已登录的用户信息
  user: _login() || {},
  permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
  apiPermissions: JSON.parse(localStorage.getItem('apiPermissions') || '[]'),
}

// getters
const getters = {
  user: state => state.user,
  permissions: state => state.permissions,
  apiPermissions: state => state.apiPermissions,
}

// actions
const actions = {
  login ({commit}, params) {
    let promised = request.alert('login', params)
    return promised
  },
  refreshToken ({commit}, params) {
    let promised = request.alert('refreshToken', params)
    return promised
  },
  getPermission ({commit}, params) {
    let promised = request.alert('getPermission', params)
    return promised
  },
  getApiPermission ({commit}, params) {
    let promised = request.alert('getApiPermission', params)
    return promised
  },
}

// mutations
const mutations = {
  LOGIN (state, token) {
    // 解析用户信息
    let userInfo = _login(token)
    // 获取到用户信息
    if (userInfo) {
      // 置入用户信息
      userInfo.customerIdArr = userInfo.customerid.split(',').map(item => parseInt(item.trim(), 10)).filter(item => !isNaN(item))
      state.user = userInfo
    }
  },
  LOGOUT (state) {
    logout()
    state.user = {}
  },
  SET_PERMISSIONS (state, data) {
    state.permissions = data.map(val => Number(val))
    localStorage.setItem('permissions', JSON.stringify(state.permissions))
  },
  SET_API_PERMISSIONS (state, data) {
    let apiPermissions = []
    if (data.roles && data.roles.length > 0) {
      apiPermissions = _.map(data.roles, 'permissions')
      apiPermissions = apiPermissions.reduce((res, cur) => {
        return res.concat(cur)
      })
      apiPermissions = _.map(apiPermissions, 'as')
    }
    if (data.permissions && data.permissions.length > 0) {
      apiPermissions = apiPermissions.concat(_.map(data.permissions, 'as'))
    }

    apiPermissions = _.union(apiPermissions)
    state.apiPermissions = apiPermissions
    localStorage.setItem('apiPermissions', JSON.stringify(state.apiPermissions))
  }
}

export const login = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/login/login.store.js